module.exports = __webpack_public_path__ + "dimer/static/img/20.73fbf0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/20.jpg
// module id = 8Ahw
// module chunks = 0